import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import TextLogo from './TextLogo';

export const imagePath = (path) => {
  return require(`../assets/images/${path}`);
};

function Footer() {
  return (
    <footer className="bg-secondary text-label">
      {/* Main Footer Content */}
      <div className="max-w-screen-xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo ve Kısa Açıklama */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3">
              <TextLogo />
            </Link>
            <p className="text-sm text-gray-300">
              Oyun terapisi, MOXO testi ve öğrenci danışmanlığı hizmetleri
            </p>
          </div>

          {/* Hizmetler */}
          <div>
            <h3 className="text-primary font-semibold mb-4">Çalışma Alanlarım</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/oyun-terapisi" className="hover:underline">Oyun Terapisi</Link>
              </li>
              <li>
                <Link to="/moxo-testi" className="hover:underline">MOXO Testi</Link>
              </li>
              <li>
                <Link to="/ogrenci-danismanligi" className="hover:underline">Öğrenci Danışmanlığı</Link>
              </li>
              <li>

              </li>
            </ul>
          </div>

          {/* İletişim Bilgileri */}
          <div>
            <h3 className="text-primary font-semibold mb-4">İletişim</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center">
                <FaMapMarkerAlt className="mr-2 text-primary" />
                <a href="https://maps.app.goo.gl/sL9XxCRfdvr5y17P7" target="_blank" rel="noreferrer" className="hover:underline">
                  Nispetiye / Etiler
                </a>
              </li>
              <li className="flex items-center">
                <FaPhoneAlt className="mr-2 text-primary" />
                <a href="tel:+905441354754" className="hover:underline">+90 544 135 47 54</a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-2 text-primary" />
                <a href="mailto:pskyagmurdemiroz@gmail.com" className="hover:underline">pskyagmurdemiroz@gmail.com</a>
              </li>
            </ul>
          </div>

          {/* Sosyal Medya ve Hızlı Bağlantılar */}
          <div>
            <h3 className="text-primary font-semibold mb-4">Takip Edin</h3>
            <div className="flex space-x-4 mb-4">
              <a href="https://www.instagram.com/psk.yagmurdemiroz" target="_blank" rel="noreferrer" className="hover:text-primary">
                <FaInstagram size={24} />
              </a>
              <a href="https://www.linkedin.com/in/ya%C4%9Fmur-demir%C3%B6z-982412205" target="_blank" rel="noreferrer" className="hover:text-primary">
                <FaLinkedin size={24} />
              </a>
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/blog" className="hover:text-underline">Blog</Link>
              </li>
              <li>
                <Link to="/hakkimda" className="hover:underline">Hakkımda</Link>
              </li>
              <li>
                <Link to="/iletisim" className="hover:text-underline">İletişim</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-primary max-w-screen-xl mx-auto px-4">
        <div className="max-w-screen-xl mx-auto px-4 py-4 flex justify-between items-center text-sm">
          <p>© 2025 Yağmur Demiröz. Tüm hakları saklıdır.</p>
          <div className="flex items-center space-x-2">
            <img src="/pine.svg" alt="Pine Software" className="w-4 h-4" />
            <a href="https://pinesoftware.net" target="_blank" rel="noreferrer" className="hover:text-primary">
              Pine Software
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;